import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core'
import { fadeIn } from '../../../animations/fadeIn'
import { flip } from '../../../animations/flip'
import { ArrowDivDirective } from '../../../directives/arrow-div.directive'

@Component({
    selector: 'app-kba-input-array',
    templateUrl: './kba-input-array.component.html',
    styleUrls: ['./kba-input-array.component.scss'],
    animations: [fadeIn, flip],
    standalone: false
})
export class KbaInputArrayComponent implements OnInit, AfterViewInit {
  @Input() block = []
  @Input() disabled = false
  @Input() chamberId
  @Input() label = ''

  @Output() inputUpdates = new EventEmitter<any>()
  @Output() inputsOut = new EventEmitter<any>()
  @Output() checkForEmptyKbaColumn = new EventEmitter<any>()

  @ViewChildren(ArrowDivDirective) inputs: QueryList<any>
  @ViewChildren('inputRef') inputRefs: QueryList<any>

  regex
  inputError = false
  rowLengthSop
  kbaIndex = 0

  constructor() {}

  ngOnInit(): void {
    this.regex = new RegExp('[*0-9aAdD]')
    if (this.label === 'Parity') {
      this.regex = new RegExp('[*eEoO]')
    }

    if (this.label === 'AscDes') {
      this.regex = new RegExp('[*aAdD]')
    }

    if (this.label === 'Mask') {
      this.regex = new RegExp('[*0-9*]')
    }

    if (this.label === 'KBA') {
      this.regex = new RegExp('[*0-9]')
    }

    if (this.label === 'SOP') {
      switch (this.chamberId) {
        case 1:
          this.regex = new RegExp('[1-5]')
          this.rowLengthSop = 5
          break
        case 2:
          this.regex = new RegExp('[1-6]')
          this.rowLengthSop = 6
          break
        case 3:
          this.regex = new RegExp('[1-7]')
          this.rowLengthSop = 7
          break
      }
    }
  }

  trackByFn(index: any, item: any) {
    return index
  }

  ngAfterViewInit() {
    this.inputsOut.emit(this.inputs)

    if (this.label === 'TMK' && this.block[0][0] === null) {
      const myInput = this.inputRefs.toArray()[0].nativeElement
      myInput.focus()
    }
  }

  setInputs(event) {
    event.target.select()
    this.inputsOut.emit(this.inputs)
  }

  onChange(event, rowIndex, index) {
    if (event.key !== 'Tab') {
      if (!this.regex.test(event.target.value) && this.label === 'KBA') {
        this.block[rowIndex][index] = ''
      } else if (!this.regex.test(event.target.value)) {
        this.block[rowIndex][index] = ''
        this.inputError = true
      } else if (this.label === 'SOP' && this.checkIfDuplicateExists(this.block[rowIndex])) {
        this.inputError = true
      } else if (this.block[rowIndex].find((x) => x !== '' || x === null)) {
        this.inputError = false
      }

      this.checkForEmptyKbaColumn.emit()
      this.inputUpdates.emit()
    }
  }

  checkIfDuplicateExists(arr) {
    if (arr.every((bit) => bit !== null)) {
      return new Set(arr).size !== arr.length
    }
  }
}
